module.exports = __webpack_public_path__ + "img/measurement-rooms-x.d655866f.svg";